export default __webpack_public_path__ + "da236bd02c028a0b12541d33aed014b7.jpg";